enum GroupRole {
    NONE = "n",
    ADMIN = "a",
    MEMBER = "m",
}

export default GroupRole;